// ****************
// precos.jsx
// autor: W de Paula
// data: 15/6/24 | 20h19
// data: 25/10/25 | 21h54 - revitalização ui/ux qween.ia
// proibida a reprodução, cópia, plágio ou uso para quaisquer fins, 
// sem autorização por escrito do autor. Sejeito às penalidas do rigor da lei.
// ****************



// src/site/components/precos.jsx
import { useNavigate } from 'react-router-dom';
import './precos.css';

function Precos() {
  const navigate = useNavigate();

  const plans = [
    {
      name: "Teste Grátis",
      price: "R$ 0",
      period: "14 dias",
      features: ["Agenda completa", "Lembretes por WhatsApp", "Link personalizado"],
      cta: "Começar agora",
      active: false,
      isFree: true
    },
    {
      name: "Starter",
      price: "R$ 29,90",
      period: "3 meses",
      total: "R$ 89,70",
      features: ["Tudo do gratuito", "Suporte prioritário", "Relatórios básicos"],
      cta: "Assinar",
      active: false
    },
    {
      name: "Pro",
      price: "R$ 19,90",
      period: "12 meses",
      total: "R$ 238,80",
      features: ["Tudo do Starter", "Relatórios avançados", "Múltiplos profissionais"],
      cta: "Mais escolhido",
      active: true
    },
    {
      name: "Premium",
      price: "R$ 14,90",
      period: "24 meses",
      total: "R$ 357,60",
      features: ["Tudo do Pro", "Desconto exclusivo", "Atualizações vitalícias"],
      cta: "Economizar 25%",
      active: false
    }
  ];

  const handleSelect = (plan) => {
    if (plan.isFree) {
      window.location.href = '/app/novaconta/prestador';
    } else {
      navigate('/precos', { state: { contrato: plan.name, duracao: plan.period, valor: plan.price } });
    }
  };

  return (
    <section id="preco" className="py-5">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold">Planos feitos para você crescer</h2>
          <p className="text-muted">Experimente grátis por 14 dias. Sem cartão. Sem risco.</p>
        </div>
        <div className="row g-4 justify-content-center">
          {plans.map((plan, i) => (
            <div key={i} className="col-lg-3">
              <div className={`card h-100 ${plan.active ? 'border-primary shadow-lg' : ''}`}>
                {plan.active && (
                  <div className="highlight_batch">Mais escolhido</div>
                )}
                <div className="card-body d-flex flex-column">
                  <h5 className="card-title fw-bold">{plan.name}</h5>
                  <div className="mt-2">
                    <span className="display-6 fw-bold">{plan.price}</span>
                    <span className="text-muted"> /mês</span>
                  </div>
                  <small className="text-muted">{plan.total && `Total: ${plan.total}`}</small>
                  <ul className="mt-3 mb-4 list-unstyled">
                    {plan.features.map((f, j) => (
                      <li key={j} className="mb-2"><i className="bi bi-check-circle-fill text-success me-2"></i> {f}</li>
                    ))}
                  </ul>
                  <button 
                    className={`btn mt-auto ${plan.active ? 'btn-primary' : plan.isFree ? 'btn-outline-success' : 'btn-outline-primary'}`}
                    onClick={() => handleSelect(plan)}
                  >
                    {plan.cta}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-4">
          <small className="text-muted">
            Garantia de 7 dias: se não amar, devolvemos seu dinheiro. Sem perguntas.
          </small>
        </div>
      </div>
    </section>
  );
}
export default Precos;